module.exports = __webpack_public_path__ + "img/mod-5.dec45016.svg";